"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalWidth = exports.GlobalStyles = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("styled-components");
var _fonts = require("../fonts");
var _notifications = require("../notifications");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var GlobalWidth = (0, _styledComponents.createGlobalStyle)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .modal-open {\n    overflow: hidden !important;\n  }\n"])));
exports.GlobalWidth = GlobalWidth;
var GlobalStyles = function GlobalStyles() {
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(GlobalWidth, null), /*#__PURE__*/_react.default.createElement(_fonts.GlobalFonts, null), /*#__PURE__*/_react.default.createElement(_notifications.GlobalToastify, null));
};
exports.GlobalStyles = GlobalStyles;